var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSupport)?_c('span',{staticClass:"rong-latest-message",class:['rong-latest-message-' + _vm.platform],domProps:{"innerHTML":_vm._s(_vm.content)}}):(_vm.isInvalid)?_c('span'):_c('span',[_vm._v(_vm._s(_vm.locale.message.unknown))])}
var staticRenderFns = []

export { render, staticRenderFns }